import { useServices } from 'containers/services';
import { type UseQueryResult, useQuery } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';
import type { GetCreditInvoicesArg, GetCreditInvoicesResponse } from 'lib/services';

export const useCreditInvoices = (filter?: GetCreditInvoicesArg): UseQueryResult<GetCreditInvoicesResponse> => {
  const { creditInvoicesApiClient } = useServices();

  return useQuery(
    QUERY_KEYS.creditInvoices.filter(filter),
    async () => await creditInvoicesApiClient.find({ ...filter, populate: ['reseller', 'customer'] }),
  );
};
